import { createPortal } from 'react-dom';
import { ReactChild } from "react";

import './modal.scss';

export interface IModalProps {
    children: ReactChild,
    onCloseClicked: () => void,
}

export const Modal: React.FC<IModalProps> = ({children, onCloseClicked}) => {
    const parentElement = document.body;

    return createPortal(
        (
            <div className="modal">
                <div className="modal-overlay" onClick={onCloseClicked}></div>
                <div className="modal-wrapper">
                    {children}
                </div>
            </div>
        ),
        parentElement
    );
}
